import React from "react";
import Table from "../components/Candidate/Table";

const Candidate = () => {
    return <div className="page"><Table /></div>;
};

export default Candidate;
